import { FC } from 'react';

import HoldingClassTableHeader from './HoldingClassTableHeader';
import HoldingClassTableBody from './HoldingClassTableBody';

const HoldingClassTable: FC = () => (
  <div className="card card-bordered card-preview">
    <div className="table-responsive">
      <table className="nk-tb-list nk-tb-ulist">
        <HoldingClassTableHeader />
        <HoldingClassTableBody />
      </table>
    </div>
  </div>
);

export default HoldingClassTable;
